import ApiService from '../services/apiService';

export const activitiesMarkingsReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/activities_markings/report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const indexActivitiesMarkingsRequest = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('get', '/activity_attendances', {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export default activitiesMarkingsReport;
